import React from 'react';
import athirudramHeaderBanner from '../assets/img/athirudram-headerbanner.png';

export default class AthirudramDetails extends React.Component {
  constructor() {
    super();
    this.state = {
      athirudramDetailsSection: []

    };
  }
  componentDidMount() {

    fetch('https://trust.sharavisual.com/data/athirudramDetails.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        this.setState({
          athirudramDetailsSection: data,
        })
        console.log('Fetched data:', data);
        // You can now use the data in your component state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }
  render() {
    return (
      <>
       
        <div class="container">

          <div class="row justify-content-around gy-4">
            <div class="col-lg-10 d-flex flex-column justify-content-center">
              <div className='row'>
                {
                  this.state.athirudramDetailsSection.length > 0 && this.state.athirudramDetailsSection.map((item, index) => {
                    return (
                      <>
                        {item.backgroundImg != "" ? <div className='row' style={{ backgroundImage: `url(${item.backgroundImg})`, backgroundSize: "cover" }}>

                          {item.img != "" && <div className='col-lg-3 d-none d-lg-block d-xl-block'>
                            <img src={item.img} className='flex-shrink-0 me-3 mb-3 img-fluid' style={{ width: "100%" }} />
                          </div>}
                          <div className={item.img == '' ? 'col-12 col-lg-12 ' : 'col-9 col-lg-9'}>
                            <div className='col-lg-12'>
                              {item.heading != "" && <h4><a href={item.link != undefined && item.link} class="text-decoration-none text-primary">{item.heading}</a></h4>}
                              {item.subTitle != "" && <h6>{item.subTitle}</h6>}
                              {item.description != "" && <p dangerouslySetInnerHTML={{ __html: item.description }}></p>}
                            </div>
                          </div>
                        </div> :
                          <>
                            {item.img != "" && <div className='col-3 col-lg-3 d-none d-lg-block d-xl-block'>
                              <img src={item.img} className='flex-shrink-0 me-3 mb-3 img-fluid' style={{ width: "240px" }} />
                            </div>}
                            <div className={item.img == '' ? 'col-12 col-lg-12' : 'col-12 col-lg-9'}>
                              <div className='col-lg-12'>
                                {item.heading != "" && <h4><a href={item.link != undefined && item.link} class="text-decoration-none text-primary">{item.heading}</a></h4>}
                                {item.subTitle != "" && <h6>{item.subTitle}</h6>}
                                {item.description != "" && <p dangerouslySetInnerHTML={{ __html: item.description }}></p>}
                              </div>
                            </div>
                          </>
                        }

                      </>
                    )
                  })
                }


              </div>


              {/* static Content */}
              <div className='row mt-4' style={{ backgroundImage: `url(https://trust.sharavisual.com/assets/athirudram/atirudram-details-bg-2.png)`, backgroundSize: "cover" }}>

                <div className="col-sm-12 col-lg-3 p-2 d-flex justify-content-center">
                  <a href='https://trust.sharavisual.com/assets/athirudram/details-athitudhram2.jpg' target='_blank'><img src="https://trust.sharavisual.com/assets/athirudram/atirudram-details-2.png" className="img-fluid mx-auto responsive" /></a>
                </div>
                <div className='col-12 col-lg-9 p-2'>

                  <p className='fs-7'>
                    One time recital of Namakam and Chamakam Mantras is known as one Rudram. Recital for 11 times Namakam followed by one Anuvakam of Chamakam is Lagu Rudram or Rudra Ekadasini, which is a popular ritual known as Prayaschittha Karma usually performed on birthdays, especially the 60 , 70 and 80th Birthday milestones. Recital of 11 Lagu Rudram is one Maha Rudram. Repeating 11 times of Maha Rudram is one Athirudram. In Athirudram 14641 times Namakam mantras and 1331 times of Chamakam mantras are recited. Athirudram can be performed with 121 Ritwiks doing the recital by forming 11 Ganas (groups) for 11 days at a stretch. Each Gana will have a Pradana Kalasa and 11 Upa Kalas. Eleven Forms of Rudra (Mahadeva, Siva, Rudra, Sankara, Neelalohitha, Easaana, Vijaya, Bhima, Devadeva, Bhava – or Bhavotbhava and Udbhava or Aadhityamaka Rudra) are invoked in each kalasa. The Recital starts with Mahanyasam, the procedure to invoke Rudra in the Kalasa and also on various parts of the human body, followed by Trisathi archana (300 names) with Bilva leaves, pradakshinam, 13 Namaskaras and prayer (with Chamakam recital).  The founders of soothras, like Bodhayana, have prescribed in detail how Mahanyasam is to be performed.  On completion of the Mahanyasa procedure, the recital of Rudram starts. After completing the Rudram recital each time, one Anuvaka of Chamakam is recited. After the completion of the 11th time of Rudra Japam, the Mrutynjaya mantra is chanted to remove the fear of death and ensure the gradual and painless release of jeeva from the human body. After completion of the 11th time of Chamaka Mantram, a Prarthana mantra (prayer) is made to lead a good life and invoke the Benedictions of the ancestors. Simultaneously Rudra Abhishekam and Rudra Homam will be performed. As you can imagine, the scale and effort required to organize Athirudram is enormous, but so are its endless benefits. Lord Shiva is known as Ashutoshi – the one who gets easily pleased with devotion and Athirudram is an embodiment of intense devotion to Lord Shiva with the sole objective to seek His blessings for universal peace, prosperity, healthy and long life for all beings.
                  </p>

                </div>
              </div>

              <div className='row mt-4'>

                {/* <div className='col-lg-3 p-2 d-flex text-sm-center'>
                  <img src={"https://trust.sharavisual.com/assets/athirudram/atirudram-details-3.png"} className='flex-shrink-0 me-3 mb-3 mx-auto img-fluid' style={{ width: "240px" }} />
                </div> */}
                <div className="col-sm-12 col-lg-3 p-2 d-flex justify-content-center">
                  <img src="https://trust.sharavisual.com/assets/athirudram/atirudram-details-3.png" className="img-fluid mx-auto responsive" />
                </div>
                <div className={'col-sm-12 col-lg-9 p-2'}>

                  <p>
                    <b> When is the next Athirudram Yangna?<br />
                      The Sree Ramakrishna Bhajana Sabha</b>
                    is planning to celebrate its Platinum Jubilee in 9th February 2026 (Monday) to 19th February 2026, coinciding with the Mahashivarathri festivities. The plan is to mark this important milestone with an <b>Athirudra Maha Yagna.</b>
                  </p>

                </div>
              </div>

            </div>
          </div>
        </div>
      </>
    );
  }
} 